/* SNUGMORA product page helpers.
   - Limited offer reminders: every element with data-snug-deadline counts down to the one end date set in
     Theme settings > SNUGMORA offer. Nothing is stored per visitor; at the end the reminder disappears and the
     gift message (data-snug-fallback) comes back.
   - Size & fit modal (CRO library size guide), keyboard accessible.
   - Optional ship-by date (off by default; only with a confirmed processing time).
   - Offer rows: one cart line per colour for 2 or 3 robes.
   - Cart "One for you. One to gift.": adds the second robe only when its button is clicked, then redraws the cart
     (drawer and cart page, no reload) with Shopify's answer, so the saving shown is the one Shopify really applied.
   - Cart gift wrapping: its own paid line, added or removed with the checkbox, kept in step with the robes (one line,
     one per robe or one per order) and removed when no robe is left.
   - Cart reservation timer: only with a real reservation end time in the cart; never restarts, never empties the cart. */
(function () {
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function initDeadlines(root) {
    (root || document).querySelectorAll('[data-snug-deadline]').forEach(function (el) {
      if (el.dataset.snugInit) return;
      el.dataset.snugInit = '1';
      var end = new Date(el.getAttribute('data-snug-deadline'));
      var wrap = el.parentElement;
      var fallback = wrap ? wrap.querySelector('[data-snug-fallback]') : null;
      var out = el.querySelector('[data-snug-left]');
      function showFallback() { el.hidden = true; if (fallback) fallback.hidden = false; }
      if (isNaN(end.getTime())) { showFallback(); return; }
      function tick() {
        var ms = end - new Date();
        if (ms <= 0) { showFallback(); return; }
        el.hidden = false;
        if (fallback) fallback.hidden = true;
        if (out) {
          var d = Math.floor(ms / 864e5), h = Math.floor(ms % 864e5 / 36e5), m = Math.floor(ms % 36e5 / 6e4);
          out.textContent = ' · ends in ' + (d > 0 ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm';
        }
        setTimeout(tick, 30000);
      }
      tick();
    });
  }

  function initSizeGuides() {
    document.querySelectorAll('[data-csg-open]').forEach(function (btn) {
      if (btn.dataset.snugInit) return;
      btn.dataset.snugInit = '1';
      var modal = document.getElementById(btn.getAttribute('data-csg-open'));
      if (!modal) return;
      if (modal.parentElement !== document.body) document.body.appendChild(modal);
      function close() {
        modal.classList.remove('is-visible');
        document.body.style.overflow = '';
        btn.focus();
      }
      btn.addEventListener('click', function () {
        modal.classList.add('is-visible');
        document.body.style.overflow = 'hidden';
        var x = modal.querySelector('[data-csg-close]');
        if (x) x.focus();
      });
      modal.addEventListener('click', function (e) {
        if (e.target === modal || e.target.hasAttribute('data-csg-close')) close();
      });
      modal.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    });
  }

  function initShipDates() {
    document.querySelectorAll('[data-snug-shipdate]').forEach(function (el) {
      var days = parseInt(el.getAttribute('data-snug-shipdate'), 10);
      var out = el.querySelector('[data-snug-shipdate-out]');
      if (!days || !out) return;
      var d = new Date();
      var added = 0;
      while (added < days) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) added++; }
      out.textContent = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
      el.hidden = false;
    });
  }

  /* Offer rows (1, 2 or 3 robes). For 2 or 3 robes, each robe has its own colour: on submit the product form sends
     one cart line per colour (items[n][id] / items[n][quantity]) instead of the single variant id. The discount itself
     comes from the matching automatic discount in Shopify, so cart and checkout show the same amounts. */
  function initOffers() {
    document.querySelectorAll('[data-snug-offers]').forEach(function (box) {
      if (box.dataset.snugInit) return;
      box.dataset.snugInit = '1';
      var form = document.querySelector('form[id^="product-form-template"][action$="/cart/add"]');
      function selected() { var r = box.querySelector('[data-snug-offer-radio]:checked'); return r ? parseInt(r.value, 10) : 1; }
      var stickyCache = null;
      function syncSticky(n, row) {
        // The sticky bar shows the same total and label as the selected offer (it submits the same form).
        var prices = document.querySelectorAll('.sticky-atc .snug-price__now');
        var labels = document.querySelectorAll('.sticky-atc .sticky-atc-active-variant__option-value');
        if (!stickyCache) stickyCache = { p: Array.prototype.map.call(prices, function (e) { return e.innerHTML; }), l: Array.prototype.map.call(labels, function (e) { return e.innerHTML; }) };
        var total = row && row.querySelector('.snug-offer__price strong');
        var title = row && row.querySelector('.snug-offer__title');
        prices.forEach(function (e, i) { e.innerHTML = (n > 1 && total) ? total.innerHTML : stickyCache.p[i]; });
        labels.forEach(function (e, i) { e.innerHTML = (n > 1 && title) ? title.innerHTML : stickyCache.l[i]; });
      }
      function refresh() {
        var n = selected(), selRow = null;
        box.querySelectorAll('.snug-offer').forEach(function (row) {
          var on = parseInt(row.dataset.qty, 10) === n;
          if (on) selRow = row;
          row.classList.toggle('is-selected', on);
          var c = row.querySelector('[data-snug-offer-colors]');
          if (c) c.hidden = !on;
        });
        syncSticky(n, selRow);
        // Express checkout buys a single robe: hide it while a 2- or 3-robe offer is selected.
        document.documentElement.classList.toggle('snug-bundle-selected', n > 1);
      }
      box.addEventListener('change', function (e) { if (e.target.matches('[data-snug-offer-radio]')) refresh(); });
      refresh();
      if (!form) return;
      form.addEventListener('submit', function () {
        var n = selected();
        if (n < 2) return;
        var row = box.querySelector('.snug-offer[data-qty="' + n + '"]');
        var counts = {};
        row.querySelectorAll('[data-snug-offer-color]').forEach(function (sel) { counts[sel.value] = (counts[sel.value] || 0) + 1; });
        var added = [], disabled = [], i = 0;
        Object.keys(counts).forEach(function (vid) {
          [['id', vid], ['quantity', counts[vid]]].forEach(function (pair) {
            var inp = document.createElement('input');
            inp.type = 'hidden'; inp.name = 'items[' + i + '][' + pair[0] + ']'; inp.value = pair[1];
            form.appendChild(inp); added.push(inp);
          });
          i++;
        });
        Array.prototype.forEach.call(form.elements, function (el) {
          if ((el.name === 'id' || el.name === 'quantity') && !el.disabled) { el.disabled = true; disabled.push(el); }
        });
        setTimeout(function () {
          added.forEach(function (x) { x.remove(); });
          disabled.forEach(function (x) { x.disabled = false; });
        }, 0);
      }, true);
    });
  }

  /* Cart requests shared by the second robe offer and the gift wrapping (snippets/snug-cart-extras.liquid).
     Shopify answers each request with the redrawn cart: the drawer, the cart icon and, on the cart page, the list and
     the summary. Everything is replaced in place with that answer (items, quantities, discounts, totals), with no page
     reload, so what is shown is always what Shopify really applied. */
  function cartSections() {
    var ids = ['cart-drawer', 'cart-icon-bubble'];
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el && el.dataset.id) ids.push(el.dataset.id);
    });
    return ids;
  }
  function cartPost(url, body) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    body.sections = cartSections().join(',');
    body.sections_url = window.location.pathname;
    return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); });
  }
  function sectionPart(html, selector) {
    if (!html) return null;
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : null;
  }
  // focus: selector of the element to focus again inside the container the visitor was using (it has been replaced).
  function redrawCart(res, origin, focus) {
    try {
      var sections = res.data.sections;
      if (!sections) { window.location.reload(); return; }
      var empty = res.data.item_count === 0; // only a removal can empty the cart
      var complete = true;
      var drawer = document.querySelector('cart-drawer');
      var panel = drawer ? drawer.querySelector('#CartDrawer') : null;
      if (panel) {
        var html = sectionPart(sections['cart-drawer'], '#CartDrawer');
        if (html === null) complete = false;
        else {
          panel.innerHTML = html;
          drawer.classList.toggle('is-empty', empty);
          var overlay = drawer.querySelector('#CartDrawer-Overlay');
          if (overlay && typeof drawer.close === 'function') overlay.addEventListener('click', drawer.close.bind(drawer));
        }
      }
      var bubble = document.getElementById('cart-icon-bubble');
      var bubbleHtml = sectionPart(sections['cart-icon-bubble'], '.shopify-section');
      if (bubble && bubbleHtml !== null) bubble.innerHTML = bubbleHtml;
      ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
        var host = document.getElementById(id);
        if (!host) return;
        var slot = host.querySelector('.js-contents');
        var part = sectionPart(sections[host.dataset.id], '.js-contents');
        if (!slot || part === null) { complete = false; return; }
        slot.innerHTML = part;
        var holder = id === 'main-cart-items' ? host.closest('cart-items') : host;
        if (holder) holder.classList.toggle('is-empty', empty);
      });
      if (!complete) { window.location.reload(); return; }
      if (focus) {
        var scope = origin === 'drawer' ? drawer : document.getElementById('main-cart-footer');
        var target = scope ? scope.querySelector(focus) : null;
        if (target) target.focus({ preventScroll: true });
      }
    } catch (e) { window.location.reload(); }
  }
  function cartOrigin(el) { return el.closest('cart-drawer') ? 'drawer' : 'page'; }

  // Second robe offer: the other colour is added only when its button is clicked. Delegated: the cart is redrawn after each change.
  function initDuo() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-snug-duo-add]') : null;
      if (!btn || btn.getAttribute('aria-busy') === 'true') return;
      e.preventDefault();
      var origin = cartOrigin(btn);
      var err = btn.parentElement.querySelector('[data-snug-duo-error]');
      if (err) err.hidden = true;
      btn.setAttribute('aria-busy', 'true');
      cartPost('cart/add.js', { items: [{ id: Number(btn.getAttribute('data-snug-duo-add')), quantity: 1 }] })
        .then(function (res) {
          if (!res.ok || res.data.status) throw new Error('add failed');
          redrawCart(res, origin, '.snug-duo--done');
        })
        .catch(function () {
          btn.removeAttribute('aria-busy');
          if (err) err.hidden = false;
        });
    });
  }

  /* Gift wrapping checkbox: ticking adds the wrapping line (one per order or one per robe) with a property that tells
     the team what to prepare; unticking removes every wrapping line. Listened to in the capture phase and stopped
     there: the theme's cart list handles every "change" inside it as a quantity field. */
  function wrapUpdates(el, quantity) {
    var updates = {};
    if (el.dataset.line) updates[el.dataset.line] = quantity;
    (el.dataset.extra || '').split(',').forEach(function (key) { if (key) updates[key] = 0; });
    return updates;
  }
  function initWrap() {
    document.addEventListener('change', function (e) {
      var box = e.target && e.target.closest ? e.target.closest('[data-snug-wrap-toggle]') : null;
      if (!box) return;
      e.stopPropagation();
      var wrap = box.closest('[data-snug-wrap]');
      var origin = cartOrigin(wrap);
      var err = wrap.querySelector('[data-snug-wrap-error]');
      if (err) err.hidden = true;
      box.disabled = true;
      wrap.setAttribute('aria-busy', 'true');
      var req = box.checked
        ? cartPost('cart/add.js', { items: [{ id: Number(wrap.dataset.variant), quantity: Math.max(1, Number(wrap.dataset.want) || 1), properties: { 'Gift wrapping': wrap.dataset.mode === 'per_robe' ? 'One per robe' : 'One for the whole order' } }] })
        : cartPost('cart/update.js', { updates: wrapUpdates(wrap, 0) });
      req.then(function (res) {
        if (!res.ok || res.data.status) throw new Error('wrap');
        redrawCart(res, origin, '[data-snug-wrap-toggle]');
      }).catch(function () {
        box.disabled = false; box.checked = !box.checked;
        wrap.removeAttribute('aria-busy');
        if (err) err.hidden = false;
      });
    }, true);
  }

  /* Keeps the gift wrapping in step with the robes after any cart change: one line only, one per order (or one per
     robe), and none when no robe is left or the option is switched off. One try per cart state. */
  var wrapSyncing = false, wrapLastTry = '';
  function syncWrap(root) {
    if (wrapSyncing) return;
    var list = (root || document).querySelectorAll('[data-snug-wrap-sync]');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      var have = Number(el.dataset.have), want = Number(el.dataset.want);
      if (have === want && !el.dataset.extra) continue;
      var tryKey = el.dataset.line + '|' + (el.dataset.extra || '') + ':' + have + '>' + want;
      if (tryKey === wrapLastTry) continue;
      wrapSyncing = true; wrapLastTry = tryKey;
      var origin = cartOrigin(el);
      cartPost('cart/update.js', { updates: wrapUpdates(el, want) })
        .then(function (res) { wrapSyncing = false; if (res.ok && !res.data.status) redrawCart(res, origin); })
        .catch(function () { wrapSyncing = false; });
      return;
    }
  }

  // Reservation timer: counts down to the end time written in the cart; hidden when there is none or when it ends.
  function initReserve(root) {
    (root || document).querySelectorAll('[data-snug-reserve]').forEach(function (el) {
      if (el.dataset.snugInit) return;
      el.dataset.snugInit = '1';
      var end = new Date(el.getAttribute('data-snug-reserve')).getTime();
      var out = el.querySelector('[data-snug-reserve-left]');
      if (isNaN(end) || !out) return;
      var timer = null;
      function tick() {
        var left = Math.floor((end - Date.now()) / 1000);
        if (!el.isConnected || left <= 0) { el.hidden = true; if (timer) clearInterval(timer); return; }
        var m = Math.floor(left / 60), sec = left % 60;
        out.textContent = pad(m) + ':' + pad(sec);
        el.hidden = false;
      }
      tick();
      timer = setInterval(tick, 1000);
    });
  }

  // Cart: pressing "−" on a line at quantity 1 removes the line, like the Remove button (the theme's handler stops at 1).
  function initMinusRemoves() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('cart-drawer .quantity__button[name="minus"], cart-items .quantity__button[name="minus"]') : null;
      if (!btn) return;
      var row = btn.closest('.cart-item');
      var input = row ? row.querySelector('input.quantity__input') : null;
      if (!input || parseInt(input.value, 10) > 1) return;
      var remove = row.querySelector('cart-remove-button button, cart-remove-button a');
      if (!remove) return;
      e.preventDefault(); e.stopImmediatePropagation();
      remove.click();
    }, true);
  }

  function init() { initDeadlines(); initSizeGuides(); initShipDates(); initOffers(); initDuo(); initWrap(); initReserve(); syncWrap(); initMinusRemoves(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // The cart drawer is re-rendered after each change: re-arm its reminders.
  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) new MutationObserver(function () { initDeadlines(drawer); initReserve(drawer); syncWrap(drawer); }).observe(drawer, { childList: true, subtree: true });
    var footer = document.getElementById('main-cart-footer');
    if (footer && window.MutationObserver) new MutationObserver(function () { initReserve(footer); syncWrap(footer); }).observe(footer, { childList: true, subtree: true });
  });
  window.SnugPdp = { initDeadlines: initDeadlines };
})();

/* SNUG urgency: one real deadline shared by the product page line and the cart timer.
   - Daily order cut-off (snippets/snug-urgency.liquid, Theme settings > SNUGMORA offer > Daily order cut-off): every
     element with data-snug-cutoff shows the time left to the next cut-off in the configured IANA time zone. The zone
     offset comes from Intl.DateTimeFormat (daylight saving included), so the cut-off is the same instant for every
     visitor, whatever their own time zone. The time left is always recomputed from that instant and the visitor's
     clock: nothing is stored, nothing restarts, and it is still right after a reload, after the cart drawer is closed
     and reopened, and after the cart is redrawn. After the cut-off it moves to the next day without a reload.
     Processing days come after the cut-off day (business days optional), delivery days are calendar days. Dates are the
     cut-off zone's dates, in English short form ("Mon, Oct 5").
   - Limited offer (block "snug_urgency", mode "offer"): the wrapper follows the shared offer line (initDeadlines above)
     and disappears with it.
   The server renders the cut-off text at its final size; this script only replaces the changing words. */
(function () {
  var DAY = 864e5;
  var WD = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function pad(n) { return n < 10 ? '0' + n : String(n); }
  // 'HH:MM' (24h) -> minutes after midnight. 23:59 and 00:00 both mean midnight, the end of the day (1440).
  function parseTime(s) {
    var m = /^([01]?\d|2[0-3]):([0-5]\d)$/.exec(String(s == null ? '' : s).trim());
    if (!m) return null;
    var v = +m[1] * 60 + +m[2];
    return v === 0 || v === 1439 ? 1440 : v;
  }
  function count(v, max) { v = Math.floor(Number(v)); return v > 0 ? Math.min(v, max) : 0; }
  function isWeekend(ms) { var d = new Date(ms).getUTCDay(); return d === 0 || d === 6; }

  // Offset in minutes of an IANA zone at a given instant (e.g. -240 for New York in summer). null: unknown zone.
  var formatters = {};
  function zoneOffset(zone, ms) {
    try {
      var f = formatters[zone] || (formatters[zone] = new Intl.DateTimeFormat('en-US', {
        timeZone: zone, hour12: false, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
      }));
      var p = {};
      f.formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = +x.value; });
      var wall = Date.UTC(p.year, p.month - 1, p.day, p.hour % 24, p.minute, p.second);
      var off = Math.round((wall - Math.floor(ms / 1000) * 1000) / 6e4);
      return isNaN(off) ? null : off;
    } catch (e) { return null; }
  }

  /* Pure date maths. cfg: { time 'HH:MM', zone (IANA), processing, business, transitMin, transitMax }.
     Returns null when the time or the zone cannot be read. Day values (today, ship, from, to) are days of the cut-off
     zone expressed as UTC midnights: read them with the UTC getters (formatDate). */
  function compute(cfg, nowMs) {
    var cut = parseTime(cfg.time);
    var off = isNaN(nowMs) ? null : zoneOffset(cfg.zone, nowMs);
    if (cut === null || off === null) return null;
    var zoned = nowMs + off * 6e4; // wall clock of the cut-off zone, read with the UTC getters
    var today = Math.floor(zoned / DAY) * DAY;
    var startDay = (zoned - today) / 6e4 >= cut ? today + DAY : today; // after today's cut-off: tomorrow
    var wall = startDay + cut * 6e4;
    var cutoffMs = wall - off * 6e4;
    var off2 = zoneOffset(cfg.zone, cutoffMs); // the clocks may change before the cut-off (daylight saving)
    if (off2 !== null && off2 !== off) cutoffMs = wall - off2 * 6e4;
    var business = cfg.business === true || cfg.business === 'true';
    var d = startDay;
    if (business) while (isWeekend(d)) d += DAY;
    var n = count(cfg.processing, 60), added = 0;
    while (added < n) { d += DAY; if (!business || !isWeekend(d)) added++; }
    var res = { cutoffMs: cutoffMs, leftMs: cutoffMs - nowMs, today: today, startDay: startDay, ship: d, from: null, to: null };
    var tMax = count(cfg.transitMax, 120), tMin = Math.min(count(cfg.transitMin, 120), tMax);
    if (tMax > 0) { res.from = d + tMin * DAY; res.to = d + tMax * DAY; }
    return res;
  }

  function formatDate(ms) { var d = new Date(ms); return WD[d.getUTCDay()] + ', ' + MON[d.getUTCMonth()] + ' ' + d.getUTCDate(); }
  // HH:MM:SS left (whole seconds, never negative).
  function formatLeft(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    return pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60);
  }
  function shipLabel(r) { return 'ships ' + (r.ship === r.today ? 'today' : r.ship === r.today + DAY ? 'tomorrow' : formatDate(r.ship)); }
  function datesLabel(r) { return r.to === null ? '' : r.from === r.to ? formatDate(r.to) : formatDate(r.from) + ' – ' + formatDate(r.to); }

  // Writes into the existing text node (no element is added or removed, so the cart observers are not woken up).
  function setText(node, txt) {
    var t = node.firstChild;
    if (t && t.nodeType === 3 && !t.nextSibling) { if (t.nodeValue !== txt) t.nodeValue = txt; }
    else if (node.textContent !== txt) node.textContent = txt;
  }
  function each(root, sel, fn) { Array.prototype.forEach.call(root.querySelectorAll(sel), fn); }

  function paint(el, nowMs) {
    var r = compute({
      time: el.getAttribute('data-time'), zone: el.getAttribute('data-zone'),
      processing: el.getAttribute('data-processing'), business: el.getAttribute('data-business'),
      transitMin: el.getAttribute('data-transit-min'), transitMax: el.getAttribute('data-transit-max')
    }, nowMs);
    if (!r) { el.hidden = true; return; } // unreadable settings: no message rather than a wrong one
    var left = formatLeft(r.leftMs), ship = shipLabel(r), dates = datesLabel(r);
    each(el, '[data-snug-cutoff-left]', function (n) { setText(n, left); });
    // Optional one-digit cells of the product card tiles, in reading order (H H M M S S); the cart timer has none.
    var digits = left.replace(/:/g, '');
    each(el, '[data-snug-cutoff-digit]', function (n, i) { setText(n, digits.charAt(i)); });
    each(el, '[data-snug-cutoff-ship]', function (n) { setText(n, ship); });
    each(el, '[data-snug-cutoff-dates]', function (n) { setText(n, dates); });
  }
  function paintAll() {
    var now = Date.now();
    each(document, '[data-snug-cutoff]', function (el) { paint(el, now); });
    return now;
  }
  // One clock for every message on the page, aligned on the second so the product page and the cart tick together.
  var timer = null;
  function tick() {
    var now = paintAll();
    clearTimeout(timer);
    timer = setTimeout(tick, 1000 - (now % 1000) + 15);
  }

  // Offer mode: the wrapper is visible only while the shared offer line inside it is.
  function initOffer(el) {
    if (el.dataset.snugInit) return;
    el.dataset.snugInit = '1';
    var line = el.querySelector('[data-snug-deadline]');
    if (!line) return;
    if (window.SnugPdp && window.SnugPdp.initDeadlines) window.SnugPdp.initDeadlines(el);
    function sync() { el.hidden = line.hidden; }
    sync();
    if (window.MutationObserver) new MutationObserver(sync).observe(line, { attributes: true, attributeFilter: ['hidden'] });
  }

  function initUrgency(root) {
    if (typeof document === 'undefined') return;
    each(root || document, '[data-snug-urgency-offer]', initOffer);
    tick();
  }

  var api = { compute: compute, zoneOffset: zoneOffset, parseTime: parseTime, formatDate: formatDate, formatLeft: formatLeft, shipLabel: shipLabel, datesLabel: datesLabel, init: initUrgency };
  if (typeof window !== 'undefined') window.SnugUrgency = api;
  if (typeof document !== 'undefined') {
    var start = function () {
      initUrgency();
      // The cart drawer and the cart page footer are redrawn after each cart change: correct the new markup at once.
      if (window.MutationObserver) {
        ['cart-drawer', '#main-cart-footer'].forEach(function (sel) {
          var host = document.querySelector(sel);
          if (host) new MutationObserver(paintAll).observe(host, { childList: true, subtree: true });
        });
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
    // Back on the tab or back from the history cache: timers were paused, catch up immediately.
    document.addEventListener('visibilitychange', function () { if (!document.hidden) tick(); });
    window.addEventListener('pageshow', tick);
    // Theme editor: the section is re-rendered when a setting changes.
    document.addEventListener('shopify:section:load', function (e) { initUrgency(e.target); });
  }
})();
